import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DateConverterService } from './date-converter.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	exports: [],
	providers: [ DateConverterService, DatePipe ]
})
export class DateConverteServiceModule {}
